<template>
  <div class="b-block__user-el__avatar">
    <div id="change-avatar-app"></div>
    <img :src="currentAvatarImg" :alt="fullName" />
    <div class="b-block__user-el__avatar__btn-holder">
      <button
        type="button"
        class="b-block__edit-btn"
        :aria-label="dictionary.edit"
        @click="showActionModal = true"></button>
    </div>

    <ModalOverlay
      v-model="showActionModal"
      background-class="b-pop-up--avatars b-pop-up__holder"
      header-background-class="b-pop-up__header">
      <template #header>
        <div class="b-pop-up__header__title">
          {{ dictionary.modalTitle }}
        </div>
      </template>
      <template #body>
        <div class="b-pop-up__content">
          <Loader v-if="loading"></Loader>

          <Alert
            v-if="!loading && errorMessages.length"
            key="submit-errors"
            :messages="errorMessages"
            dismiss-by-native=""
            @close="removeErrors"></Alert>

          <Swiper
            slides-per-view="auto"
            :centered-slides="true"
            :space-between="0"
            :auto-height="true"
            :breakpoints="{
              320: {
                spaceBetween: 0,
              },
            }"
            :navigation="{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }"
            :pagination="{
              el: '.avatar-pagination',
              type: 'bullets',
              dynamicBullets: true,
              clickable: true,
            }"
            @swiper="onSwiper">
            <SwiperSlide v-for="(item, index) in records" :key="index">
              <label :for="item.id" @click="setCurrentSlide(index)">
                <input
                  :id="item.id"
                  v-model="avatarModel"
                  class="ui-helper-hidden-accessible"
                  :value="item.id"
                  type="radio" />
                <img :src="item.img" alt="" />
              </label>
            </SwiperSlide>
            <div class="swiper__nav">
              <div class="swiper-button-prev"></div>
              <div class="swiper-pagination avatar-pagination"></div>
              <div class="swiper-button-next"></div>
            </div>
          </Swiper>
          <div class="b-pop-up--avatars__btn-area">
            <button
              type="button"
              class="b-pop-up--avatars__btn-change-image"
              :disabled="isDisabled"
              @click="updateCurrentAvatar">
              <span>{{ dictionary.btnText }}</span>
            </button>
          </div>
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeMount, onMounted, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import ModalOverlay from '../components/ModalOverlay.vue'
import Loader from '../components/Shared/Loader.vue'
import Alert from '../components/Shared/Alert.vue'
import postRequestHandler from '../../lib/postRequestHandler'
import { getData, updateDomAvatarImages } from '../../lib/lib'
import jquery from 'jquery'
const {
  avatars,
  dictionary: dictionaryData,
  configuration: config,
} = getData('changeAvatarData')

const { avatar, fullName, endpointSubmitData, refresh } = config

const dictionary = ref(dictionaryData)
const currentAvatarId = ref(avatar)

const avatarModel = ref(avatar)
const showActionModal = ref(false)
const loading = ref(false)
const errorMessages = ref([])
const records = ref([...avatars])

const swiper = ref({})

const currentAvatarImg = ref('')

const setCurrentAvatarImg = () => {
  if (records.value.length) {
    const current = records.value.find(
      (item) => item.id === currentAvatarId.value
    )
    if (current && current.img) {
      currentAvatarImg.value = current.img
    }
  }
}

onBeforeMount(() => {
  setCurrentAvatarImg()
})

onMounted(() => {
  jquery('.b-block__user-el__avatar__btn-holder')
    .find('.b-block__edit-btn')
    .on('click', () => {
      showActionModal.value = true
    })
})

const onSwiper = (swip) => {
  swiper.value = swip
}

const setCurrentSlide = (indx) => {
  swiper.value.slideTo(indx)
}

const isDisabled = computed(() => {
  return avatarModel.value === currentAvatarId.value
})

const updateCurrentAvatar = async () => {
  removeErrors()
  loading.value = true

  const postData = {
    avatar: avatarModel.value,
  }

  await postRequestHandler({
    postData,
    endpoint: endpointSubmitData,
    successCallback: handleSuccess,
    errorCallback: handleError,
    refreshTokenHandler: refresh,
    captchaAction: config.captchaAction,
  })
}
const handleSuccess = async () => {
  const current = records.value.find(
    (avatar) => avatar.id === avatarModel.value
  )
  currentAvatarId.value = current.id
  setCurrentAvatarImg()
  await nextTick()
  updateDomAvatarImages(currentAvatarImg.value)
  showActionModal.value = false
  loading.value = false
}
const handleError = async (messages) => {
  if (!messages) {
    showError(dictionary.value.defaultErrorMessage)
  } else {
    showError(messages)
  }
  loading.value = false
}

const showError = (mess) => {
  if (typeof mess === 'string') {
    errorMessages.value = [mess]
  } else {
    errorMessages.value = [...mess]
  }
}

const removeErrors = () => {
  errorMessages.value = []
}
</script>
